import React from 'react';
import { Section, SectionHeading } from '../Section';
import { CtaButton } from '../CtaButton';
const pillars = ['Clinical Protocols', 'Decision Maps', 'Checklists', 'Risk Audits', 'Case Planning', 'Quick References'];
export function Author() {
  return <Section tone="dark" id="author" data-id="element-58" data-mp="1rpyohpi0fufl">
      <SectionHeading eyebrow="🦷 Meet your author" title="Dr. Karito" subtitle="Turning clinical knowledge into a practical system." data-id="element-59" data-mp="1roxcnit673wt" />

      <div className="mt-9 grid items-center gap-6 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)]" data-id="element-60" data-mp="20iaamz63cvpr">
        <img src="https://cdn.magicpatterns.com/uploads/gXuKCBT2jbf2PQRys87Hyh/Dra._Karito_Odontologa.png" alt="Portrait of Dr. Karito in her dental clinic" className="w-full rounded-2xl border border-gold-500/25 object-cover" width={945} height={1560} loading="lazy" data-id="element-61" data-mp="2ff9h2jp7iiin" />

        <div className="space-y-4 text-[15px] leading-relaxed text-slate-300 sm:text-base" data-id="element-62" data-mp="g3qjf19cswoa">
          <p data-id="element-63" data-mp="3gfdzvpy2ozlf">
            Dr. Karito created the Oclusion Clinical Playbook™ after recognizing a challenge shared by
            many dentists: the amount of information available is enormous — but having information
            isn’t the same as having a process.
          </p>
          <p data-id="element-64" data-mp="3u6asvhvwvit0">
            Complex rehabilitation cases require dentists to consider multiple variables, recognize
            important clinical signals and make decisions in the right sequence. The Playbook was
            designed to make that process easier to organize.
          </p>

          <blockquote className="rounded-2xl border-l-4 border-gold-500 bg-navy-950 p-5" data-id="element-65" data-mp="c0e98a0qvczw">
            <p className="font-display text-lg italic leading-snug text-white sm:text-xl" data-id="element-66" data-mp="gz8y9tpb1xsg">
              “You don’t always need more information. Sometimes you need a better way to use the
              information you already have.”
            </p>
            <footer className="mt-3 text-[13px] font-bold uppercase tracking-[0.16em] text-gold-500" data-id="element-67" data-mp="2irdrr9mgd35a">
              — Dr. Karito
            </footer>
          </blockquote>

          <ul className="flex flex-wrap gap-2" data-id="element-68" data-mp="3h36tui5cd7ap">
            {pillars.map(pillar => <li key={pillar} className="rounded-full border border-gold-500/30 bg-navy-950 px-3 py-1.5 text-[12px] font-semibold text-gold-400" data-id="element-69" data-mp="3v2poq9956m52">
                {pillar}
              </li>)}
          </ul>
          <p className="font-semibold text-white" data-id="element-70" data-mp="8sn3lsq5lily">Everything organized in one place.</p>
        </div>
      </div>

      <div className="mt-9 flex justify-center" data-id="element-71" data-mp="hna54dsp5asx">
        <CtaButton label="Get Dr. Karito’s clinical system" subLabel="$27 one-time · Lifetime access" data-id="element-72" data-mp="hm06nnhxm0lr" />
      </div>
    </Section>;
}